module.exports = __webpack_public_path__ + "static/img/welcome-small@2x.1286f6da.png";